/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbSmsSuiviGridDto } from './FcbSmsSuiviGridDto';
import {
    FcbSmsSuiviGridDtoFromJSON,
    FcbSmsSuiviGridDtoFromJSONTyped,
    FcbSmsSuiviGridDtoToJSON,
} from './FcbSmsSuiviGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbSmsSuiviGridDtoPaginatedResults
 */
export interface FcbSmsSuiviGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbSmsSuiviGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbSmsSuiviGridDto>}
     * @memberof FcbSmsSuiviGridDtoPaginatedResults
     */
    results?: Array<FcbSmsSuiviGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbSmsSuiviGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbSmsSuiviGridDtoPaginatedResults interface.
 */
export function instanceOfFcbSmsSuiviGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbSmsSuiviGridDtoPaginatedResultsFromJSON(json: any): FcbSmsSuiviGridDtoPaginatedResults {
    return FcbSmsSuiviGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbSmsSuiviGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbSmsSuiviGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbSmsSuiviGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbSmsSuiviGridDtoPaginatedResultsToJSON(value?: FcbSmsSuiviGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbSmsSuiviGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

